export default [
    {
        name: 'maintain',
        path: 'maintain',
        meta: { title: '系统维护' },
        component: ()=>import('@/pages/maintain/index.vue')
    }
]
